<div class="account-parent">
  <div class="account-setup" *ngIf="(currentScreenFlow === AccountSetupFlow.emailConfirm) || (currentScreenFlow === AccountSetupFlow.contractNum)">
    <div>
      <div class="col-12">
        <div class="heading" role="heading" aria-level="1">
          {{heading}} <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
        </div>
      </div>
    </div>
    <!-- TODO: Contract Number Flow to own component -->
    <div class="zip-code-flow" *ngIf="currentScreenFlow === AccountSetupFlow.contractNum">
      <form (ngSubmit)="recaptchaExecute(captchaRef)" [formGroup]="findContractForm">
        <div class="padding-mobile-left-right">
          <div class="col-12">
            <div class="subheading">
              <adp-label labelKey="Signup_NewContract_SubHeading_Text"></adp-label>
            </div>
            <div class="subheading_instruction">
              <adp-label labelKey="Signup_NewContract_Body_Text"></adp-label>
            </div>
            <mat-error class="error-message">{{contractZipError}}</mat-error>
          </div>
        </div>
        <div class="zip-form">
          <adp-input class="w-100" [resourceData]="resourceService.getResourceObject('Signup_NewContract_ContractNumber_Field')" formControlName="contractNumber"></adp-input>
          <adp-input class="w-100" [resourceData]="resourceService.getResourceObject('Signup_NewContract_ZipCode_Field')" formControlName="zipCode"></adp-input>

          <div class="form-group mt-4">
            <button mat-flat-button class="next-btn" color="accent" type="submit" [disabled]="!findContractForm.valid">
              <adp-label labelKey="Signup_NewContract_SubmitButton_Text"></adp-label>
            </button>
          </div>
        </div>
      </form>
      <re-captcha class="d-inline-block" size="invisible" [siteKey]="reCaptchaInvisbleKey"
        (resolved)="$event && onNextZipBtn($event, captchaRef)" #captchaRef="reCaptcha">
      </re-captcha>
    </div>
    <div *ngIf="currentScreenFlow === AccountSetupFlow.emailConfirm">
      <app-email-confirmation-flow [emailAddress]="maskEmailAddress" (emailConfirmed)="emailConfirmed($event)"></app-email-confirmation-flow>
    </div>
  </div>
  <div *ngIf="currentScreenFlow === AccountSetupFlow.passwordSetup">
    <app-password-setup (passwordChanged)="passwordChanged($event)"></app-password-setup>
  </div>
  <div *ngIf="currentScreenFlow === AccountSetupFlow.success">
    <app-success-screen (changeHeading)="changeHeading()"></app-success-screen>
  </div>
  <div *ngIf="currentScreenFlow === AccountSetupFlow.weKnowYou">
    <pgh-we-know-you [emailAddress]="maskEmailAddress" (changeHeading)="setWeKnowYouHeading()"></pgh-we-know-you>
  </div>
</div>